var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import { styled } from "@fluentui/react/lib/Utilities";
import { BasePicker, TagItem, TagItemSuggestion } from "@fluentui/react/lib/Pickers";
import { getStyles } from "@fluentui/react/lib/components/pickers/BasePicker.styles";
class BaseTagPicker extends BasePicker {
}
__publicField(BaseTagPicker, "defaultProps", {
  onRenderItem: (props) => /* @__PURE__ */ jsx(TagItem, __spreadProps(__spreadValues({}, props), { children: props.item.name })),
  onRenderSuggestionsItem: (props) => /* @__PURE__ */ jsx(TagItemSuggestion, { children: props.name })
});
const TagPickerWrapper = styled(
  BaseTagPicker,
  getStyles,
  void 0,
  {
    scope: "TagPicker"
  }
);
export {
  BaseTagPicker,
  TagPickerWrapper
};
//# sourceMappingURL=TagPickerWrapper.js.map
